import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    height: "inherit",
    width: "inherit",
    maxWidth: props.width,
    flexGrow: 1,
    "& .react-swipeable-view-container, & > div:nth-of-type(1)": {
      height: "inherit",
    },
  }),
  img: (props) => ({
    height: "100%",
    width: "100%",
    objectFit: props.contain ? "contain" : "cover",
    display: "block",
    // maxWidth: props.width,
    overflow: "hidden",
  }),
  imgContainer: (props) => ({
    maxHeight: props.contain ? 200 : "inherit",
    height: "100%",
    overflow: "hidden",
  }),
  dotsContainer: {
    zIndex: 800,
    width: "100%",
    bottom: 0,
    position: "absolute",
    padding: "8px 0",
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "center",
  },
  displayNone: {
    display: "none",
  },
  textVariant: {
    fontSize: 12,
    marginLeft: "calc(100% - 50px)",
    marginBottom: 5,
    padding: 3,
    borderRadius: theme.shape.borderRadiusMain,
    color: theme.palette.basic.white,
    backgroundColor: "rgba(34, 34, 34, 0.66)",
    width: 36,
  },
}));

export default useStyles;
